const StudentExpresss = () => {
    return (
      <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Students Express
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS Students Express provides a reliable, convenient and affordable way for students to send their 
              academic documents locally and abroad. For documents’ shipment only, this service benefits prospective 
              students and alumni in need of safely sending and receiving letters, educational transcripts or other 
              important documents to and from educational institutions worldwide. The service additionally helps students 
              by allowing them to despatch important documents anywhere in the world for a flat rate.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img src="/DomesticScrollingBanner/image10.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </div>
      
      </div>
    </div>

  )
};
export default StudentExpresss;